module.exports = __webpack_public_path__ + "static/media/Group 29177.3b954343.png";